import { AssetType, InputType } from "../../../types";

const assetTypeLabels: Record<AssetType, string> = {
  land_management_unit: "Land Management Unit",
  fertilizer_production_facility: "Fertilizer Production Facility",
  generic: "Generic Asset"
};

const inputTypeLabels: Record<InputType, string> = {
  conventional_fertilizer: "Conventional Fertilizer",
  nitrogen_stabilized_fertilizer: "Nitrogen Stabilized Fertilizer",
  controlled_release_fertilizer: "Controlled Release Fertilizer",
  low_carbon_fertilizer: "Low Carbon Fertilizer",
  fuel: "Fuel",
  other: "Other"
};

export const getAssetTypeLabel = (type: AssetType): string => {
  return assetTypeLabels[type] || type;
};

export const getInputTypeLabel = (type: InputType): string => {
  return inputTypeLabels[type] || type;
};

export const assetTypeOptions = Object.entries(assetTypeLabels).map(([value, label]) => ({
  value,
  label
}));

export const inputTypeOptions = Object.entries(inputTypeLabels).map(([value, label]) => ({
  value,
  label
})); 